import { XIcon } from 'lucide-react'
import React from 'react'

const ModalHeader = ({ handleClose, title }) => {
    return (
        <div className='flex justify-between py-5'>
            <h2 className='text-xl font-semibold'>
                {title}
            </h2>
            <XIcon className='hover:cursor-pointer' onClick={handleClose} size={25} />
        </div>
    )
}

export default ModalHeader
